<template>
  <div v-if="invitations">
    <vs-popup :title="$t('InvitationLinkTitle')" :active.sync="showLinkPopup" v-if="showLinkPopup">
      <div>
        <div class="vx-row">
          <div class="vx-col w-1/1">
            {{ $t('UseThisLinkToInvite') }}
          </div>
          <div class="vx-col w-1/1">
            <vs-input v-model="selectedInvitationLink" style=""></vs-input>
            <vs-button color="dark" @click="CopyLink" type="line" style="float:left;" icon-pack="feather" icon="icon-copy" icon-after></vs-button>
          </div>
        </div>
      </div>
    </vs-popup>

    <div class="flex justify-end mb-4">
      <vs-button color="primary"
                 type="filled"
                 icon="person_add"
                 @click="$emit('invite-user')"
                 class="mr-2">
        {{ $t('InviteUser') }}
      </vs-button>
      <vs-button 
        color="primary" 
        type="filled" 
        icon="refresh"
        @click="LoadInvitations">
        {{ $t('Refresh') }}
      </vs-button>
    </div>

    <vs-table ref="table" v-model="selection" :data="invitations" multiple>
      <template slot="thead">
        <vs-th>{{ $t('EmailHeader') }}</vs-th>
        <vs-th>{{ $t('RolesHeader') }}</vs-th>
        <vs-th>{{ $t('CreatedHeader') }}</vs-th>
        <vs-th>{{ $t('ExpiresHeader') }}</vs-th>
        <vs-th>{{ $t('StatusHeader') }}</vs-th>
        <vs-th>{{ $t('VisitsHeader') }}</vs-th>
        <vs-th>{{ $t('InvitedByHeader') }}</vs-th>
        <vs-th>{{ $t('ActionsHeader') }}</vs-th>
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td style="vertical-align: top">
              <p class="product-category" style="max-height: 1.2em; overflow: hidden" v-html="tr.email"></p>
            </vs-td>
            <vs-td style="vertical-align: top">
              <vs-chip v-for="role in tr.roles"
                       :key="role.id"
                       color="primary"
                       class="mr-2 mb-1">
                {{ role.name }}
              </vs-chip>
            </vs-td>
            <vs-td style="vertical-align: top">
              <div class="product-category">
                <div v-for="(part, i) in formatDate(tr.createdDate)" :key="i">
                  {{ part }}
                </div>
              </div>
            </vs-td>
            <vs-td style="vertical-align: top">
              <div class="product-category">
                <div v-for="(part, i) in formatDate(tr.expiresAt)" :key="i">
                  {{ part }}
                </div>
              </div>
            </vs-td>
            <vs-td style="vertical-align: top">
              <vs-chip :color="tr.isExpired ? 'danger' : 'success'">
                {{ tr.isExpired ? $t('ExpiredStatus') : $t('ActiveStatus') }}
              </vs-chip>
            </vs-td>
            <vs-td style="vertical-align: top">
              <p class="product-category">{{ tr.visitCount }}</p>
              <p v-if="tr.lastVisitedAt" class="product-category text-xs">
                {{ $t('LastVisit') }} {{ formatDate(tr.lastVisitedAt)[0] }}
              </p>
            </vs-td>
            <vs-td style="vertical-align: top">
              <p class="product-category" style="max-height: 1.2em; overflow: hidden" v-html="tr.invitedBy"></p>
            </vs-td>
            <vs-td style="vertical-align: top">
              <vs-dropdown style="cursor: pointer" vs-trigger-click>
                <span style="font-size: 12px">{{ $t('ActionsHeader') }}</span>
                <vs-dropdown-menu>
                  <vs-dropdown-group :vs-label="$t('InvitationGroup')">
                    <vs-dropdown-item @click.stop="copyInvitationLink(data[indextr])" :disabled="tr.isExpired">
                      {{ $t('CopyLinkAction') }}
                    </vs-dropdown-item>
                    <vs-dropdown-item @click.stop="resendInvitation(data[indextr])" :disabled="tr.isExpired">
                      {{ $t('ResendEmailAction') }}
                    </vs-dropdown-item>
                  </vs-dropdown-group>
                </vs-dropdown-menu>
              </vs-dropdown>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-pagination :total="Math.ceil(totalCount / itemsPerPage)" v-model="currentPage" :max="10" class="mt-5" />
  </div>
</template>

<script>
import TCVelikClient from '@/TCVelikClient/TCVelikClient.js';

export default {
  data() {
    return {
      invitations: [],
      totalCount: 0,
      itemsPerPage: 10,
      currentPage: 1,
      selection: [],
      showLinkPopup: false,
      selectedInvitationLink: null
    };
  },
  mounted() {
    this.LoadInvitations();
  },
  methods: {
    LoadInvitations() {
      var instance = this;
      
      TCVelikClient.GetRelative("/api/admin/GetInvitations").then(function (response) {
        if (response && response.data) {
          instance.$set(instance, "invitations", response.data);
          instance.$set(instance, "totalCount", response.data.length);
        }
      }).catch(err => {
        instance.$vs.notify({
          title: instance.$t('ErrorLoadingInvitations'),
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
          time: 5000,
        });
      });
    },

    formatDate(dateString) {
      const moment = require("moment");
      const m = moment(dateString);
      return [m.format("MMM") + " " + m.format("DD") + " " + m.format("YYYY"), m.format("h:mm:ss a")];
    },

    copyInvitationLink(invitation) {
      this.selectedInvitationLink = invitation.invitationLink;
      this.showLinkPopup = true;
    },

    CopyLink() {
      var instance = this;
      this.$copyText(this.selectedInvitationLink).then(
        function () {
          instance.$vs.notify({
            title: instance.$t('Success'),
            text: instance.$t('InvitationLinkCopied'),
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
          instance.showLinkPopup = false;
        }
      );
    },

    resendInvitation(invitation) {
      var instance = this;
      if (confirm(instance.$t('ResendInvitationConfirm').replace('{email}', invitation.email))) {
        const requestData = {
          invitationId: invitation.invitationId
        };

        TCVelikClient.PostRelative("/api/admin/ResendInvitation", requestData).then(function (response) {
          if (response && response.data && response.data.success) {
            instance.$vs.notify({
              title: instance.$t('InvitationResent'),
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
              time: 5000,
            });
          }
        }).catch(err => {
          instance.$vs.notify({
            title: instance.$t('ErrorResendingInvitation'),
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
            time: 5000,
          });
        });
      }
    }
  },
  watch: {
    'currentPage'(newVal, oldVal) {
      // Handle pagination if needed
    },
    'selection'(newVal, oldVal) {
      this.$emit("SelectionChanged", newVal);
    }
  }
};
</script>

<style scoped>
.text-xs {
  font-size: 0.75rem;
}
</style>
